export default __webpack_public_path__ + "static/media/cappuaccino.3f7df2f5.png";